/**
 * Cart drawer footer — totals + checkout CTA. Renders only when there's
 * at least one item.
 */
import { Link } from "react-router-dom";
import { formatMoney } from "../../lib/cart";

function Row({ label, value, strong = false, tone = "default" }) {
    return (
        <div className="flex justify-between items-baseline">
            <span
                className={`text-zen-ink-soft uppercase tracking-[0.2em] text-[10px] ${
                    strong ? "text-zen-ink" : ""
                }`}
            >
                {label}
            </span>
            <span
                className={`${strong ? "font-serif text-2xl text-zen-ink font-light" : "text-sm"} ${
                    tone === "olive" ? "text-zen-olive" : ""
                }`}
            >
                {value}
            </span>
        </div>
    );
}

export default function CartFooter({ priceSummary, storeSlug, onClose }) {
    const ps = priceSummary;
    return (
        <footer className="border-t border-zen-ink/10 px-6 sm:px-8 py-6 bg-zen-surface">
            <div className="space-y-2 mb-6 text-sm">
                <Row label="Subtotal" value={formatMoney(ps?.subtotal)} />
                {ps?.discounts ? (
                    <Row
                        label="Discounts"
                        value={`− ${formatMoney(ps.discounts)}`}
                        tone="olive"
                    />
                ) : null}
                <Row label="Tax" value={formatMoney(ps?.taxes)} />
                <Row label="Total" value={formatMoney(ps?.total)} strong />
            </div>
            <Link
                to={`/checkout/${storeSlug}`}
                onClick={onClose}
                data-testid="cart-checkout-cta"
                className="block text-center bg-zen-olive hover:bg-zen-olive-dark text-zen-bg py-4 font-medium uppercase tracking-[0.25em] text-[11px] transition-colors"
            >
                Continue to checkout
            </Link>
            <p className="text-[10px] text-zen-muted text-center mt-4 leading-relaxed">
                Continue to delivery / pickup, then secure payment & ID verification.
            </p>
        </footer>
    );
}
